/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum NegotiationMaterialsAliases {
  AVATAR_0 = 'avatar-0',
  AVATAR_MATERIAL = 'avatar-material',
  CARD_MATERIAL = 'card-material',
  CHECKBOX_0 = 'checkbox-0',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DECK_0 = 'deck-0',
  FETCH_MATERIAL = 'fetch-material',
  FETCH_MATERIALS = 'fetch-materials',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_2 = 'field-2',
  FIELD_AVATAR = 'field-avatar',
  FIELD_CODE = 'field-code',
  FIELD_CP_VALUE = 'field-cp-value',
  FIELD_DESCRIPTION = 'field-description',
  FIELD_MATERIAL_CP_VALUE = 'field-material-cp-value',
  FIELD_MATERIAL_VALUE = 'field-material-value',
  FIELD_NEW_VALUE = 'field-new-value',
  FIELD_SEQ = 'field-seq',
  FILTER_0 = 'filter-0',
  FILTERED_LIST_0 = 'filtered-list-0',
  FORM_MATERIAL = 'form-material',
  INPUT_0 = 'input-0',
  INPUT_CODE = 'input-code',
  INPUT_CP_VALUE = 'input-cp-value',
  INPUT_DESCRIPTION = 'input-description',
  LEGENDS_0 = 'legends-0',
  MAPPER_0 = 'mapper-0',
  MAPPER_AVATAR = 'mapper-avatar',
  MODAL_MATERIAL = 'modal-material',
  PANEL_0 = 'panel-0',
  PANEL_MODAL_MATERIAL = 'panel-modal-material',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_SWQ = 'text-swq',
}
export { NegotiationMaterialsAliases };
